export default __webpack_public_path__ + "static/media/goshen20.e945463f.jpg";